const mutations = {
  add(state, object) {
    state.itens.push(object);
  },
  setList(state, list) {
    state.itens = list;
  }
};

export default mutations;
